<div class="index-management" ng-controller="indexController as ctrl">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>